export default {
  shadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.15)',
};
